export const CHANGE_LAYOUT_NAME = 'CHANGE_LAYOUT_NAME';
export const FETCHING_LAYOUTS = 'FETCHING_LAYOUTS';
export const FETCH_LAYOUTS_FAILED = 'FETCH_LAYOUTS_FAILED';
export const LAYOUT_RESET = 'LAYOUT_RESET';
export const LOAD_LAYOUTS = 'LOAD_LAYOUTS';
export const RESET_LAYOUTS_LIST = 'RESET_LAYOUTS_LIST';
export const START_ORIGINAL_LAYOUT_RESET = 'START_ORIGINAL_LAYOUT_RESET';
export const SAVING_FAILED = 'SAVING_FAILED';
export const UPDATE_DECK_LAYOUTS = 'UPDATE_DECK_LAYOUTS';
